import {useQuery} from '@tanstack/react-query'

import {listUnitsOnRent} from './api'
import {unitsOnRentKeys} from './query-keys'

export function useUnitsOnRent(
    jobId: string,
    rentalAssetTypeId: string | null | undefined,
    options?: {enabled?: boolean},
) {
    return useQuery({
        queryKey: unitsOnRentKeys.forJob(jobId, rentalAssetTypeId ?? ''),
        queryFn: () => listUnitsOnRent(jobId, rentalAssetTypeId!),
        enabled: (options?.enabled ?? true) && Boolean(jobId && rentalAssetTypeId),
        staleTime: 0,
    })
}
